// Chrome 38 is the first version with TextEncoder. The login QR code
// (react-qr-code) encodes its value with `new TextEncoder().encode(...)`,
// which throws "TextEncoder is not defined" on older browsers such as Chrome 30.
if (window.TextEncoder === undefined) {
  function TextEncoderPolyfill() {
    this.encoding = 'utf-8';
  }

  TextEncoderPolyfill.prototype.encode = function (input?: string) {
    const value = input == null ? '' : String(input);
    const bytes: number[] = [];

    for (let index = 0; index < value.length; index += 1) {
      let codePoint = value.charCodeAt(index);

      // Join a UTF-16 surrogate pair into one code point. charCodeAt is used
      // because String#codePointAt is also missing on these old browsers.
      // A lone surrogate is replaced with U+FFFD, matching native TextEncoder.
      if (codePoint >= 0xd800 && codePoint <= 0xdbff && index + 1 < value.length) {
        const next = value.charCodeAt(index + 1);
        if (next >= 0xdc00 && next <= 0xdfff) {
          codePoint = 0x10000 + ((codePoint - 0xd800) << 10) + (next - 0xdc00);
          index += 1;
        } else {
          codePoint = 0xfffd;
        }
      } else if (codePoint >= 0xd800 && codePoint <= 0xdfff) {
        codePoint = 0xfffd;
      }

      if (codePoint <= 0x7f) {
        bytes.push(codePoint);
      } else if (codePoint <= 0x7ff) {
        bytes.push(0xc0 | (codePoint >> 6), 0x80 | (codePoint & 0x3f));
      } else if (codePoint <= 0xffff) {
        bytes.push(
          0xe0 | (codePoint >> 12),
          0x80 | ((codePoint >> 6) & 0x3f),
          0x80 | (codePoint & 0x3f),
        );
      } else {
        bytes.push(
          0xf0 | (codePoint >> 18),
          0x80 | ((codePoint >> 12) & 0x3f),
          0x80 | ((codePoint >> 6) & 0x3f),
          0x80 | (codePoint & 0x3f),
        );
      }
    }

    return new Uint8Array(bytes);
  };

  window.TextEncoder = TextEncoderPolyfill as unknown as typeof TextEncoder;
}

export {};
